// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/Assets/Donation/LandingPage/landingBrightness.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/Assets/Donation/LandingPage/mobileBackground.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://api.fontshare.com/v2/css?f[]=satoshi@400,500,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.donationLandingPage {
  background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0) 70%,
      rgba(0, 0, 0, 1) 90%
    ),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100%;
  
}

.donationLandingPageContainer {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  height: 100%;
  position: relative;
}

.motionTextContainer {
  position: absolute;
  top: 74%;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
}
.motionTextWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}
.motionText {
  font-size: 216.43px;
  font-weight: bold;
  background: linear-gradient(to bottom, #6ed0b8 25%, #235448 85%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  white-space: nowrap;
  display: inline-block;
  animation: moveText 30s linear infinite;
  opacity: 85%;
  z-index: 5;
}



@keyframes moveText {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}
.scrollDownContainer{
  display: flex;
  justify-content: center;
  margin-top: 4vh;
}
.scrollDownContainer2{
  display: flex;
  align-items: center;
  gap: 8px;
}
.scrollDownText{
  font-family: 'Satoshi', sans-serif;
  font-size: 14px;
}

@media screen and (max-width: 1750px){
  .motionText {
    font-size: 180.43px;
  }
}

@media screen and (max-width: 1640px){
  .motionText {
    font-size: 160.43px;
  }
  .scrollDownText{
    font-family: 'Satoshi', sans-serif;
    font-size: 13px;
  }
}

@media screen and (max-width: 1540px){
  .motionText {
    font-size: 140.43px;
  }
}

@media screen and (max-width: 1440px){
  .motionText {
    font-size: 125.3px;
  }
}


@media screen and (max-width: 1024px) {
  .motionTextContainer {
    padding-top: 15vh;
    position: absolute;
    top: 120%;
  }
  .motionText {
    font-size: 100px;
  }
  .scrollDownText{
    font-family: 'Satoshi', sans-serif;
    font-size: 14px;
  }
  .motionTextContainer {
    top: 60%;
  }
}
@media screen and (max-width: 768px) {
  .LandingPage {
    background-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0) 70%,
        rgba(0, 0, 0, 1) 90%
      ),
      url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
    height: 100%;
  }
  .donationLandingPageContainer{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .motionTextContainer {
    top: 98%;
    padding-top: 0vh;
  }
  .motionText {
    font-size: 60px;
  }
  .scrollDownContainer{
    margin-top: 9vh;
  }
  .scrollDownText{
    font-family: 'Satoshi', sans-serif;
    font-size: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Donation/LandingPage/LandingPage.css"],"names":[],"mappings":"AAEA;EACE;;;;;2CAK6E;EAC7E,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,YAAY;;AAEd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gEAAgE;EAChE,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;EACrB,uCAAuC;EACvC,YAAY;EACZ,UAAU;AACZ;;;;AAIA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,kCAAkC;IAClC,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;;AAGA;EACE;IACE,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kCAAkC;IAClC,eAAe;EACjB;EACA;IACE,QAAQ;EACV;AACF;AACA;EACE;IACE;;;;;6CAK4E;IAC5E,4BAA4B;IAC5B,sBAAsB;IACtB,2BAA2B;IAC3B,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;EACA;IACE,QAAQ;IACR,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kCAAkC;IAClC,eAAe;EACjB;AACF","sourcesContent":["@import url('https://api.fontshare.com/v2/css?f[]=satoshi@400,500,700&display=swap');\n\n.donationLandingPage {\n  background-image: linear-gradient(\n      to bottom,\n      rgba(0, 0, 0, 0) 70%,\n      rgba(0, 0, 0, 1) 90%\n    ),\n    url(\"../../../../public/Assets/Donation/LandingPage/landingBrightness.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  width: 100%;\n  height: 100%;\n  \n}\n\n.donationLandingPageContainer {\n  display: flex;\n  justify-content: space-between;\n  align-items: stretch;\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.motionTextContainer {\n  position: absolute;\n  top: 74%;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  display: flex;\n}\n.motionTextWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.motionText {\n  font-size: 216.43px;\n  font-weight: bold;\n  background: linear-gradient(to bottom, #6ed0b8 25%, #235448 85%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  white-space: nowrap;\n  display: inline-block;\n  animation: moveText 30s linear infinite;\n  opacity: 85%;\n  z-index: 5;\n}\n\n\n\n@keyframes moveText {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n.scrollDownContainer{\n  display: flex;\n  justify-content: center;\n  margin-top: 4vh;\n}\n.scrollDownContainer2{\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.scrollDownText{\n  font-family: 'Satoshi', sans-serif;\n  font-size: 14px;\n}\n\n@media screen and (max-width: 1750px){\n  .motionText {\n    font-size: 180.43px;\n  }\n}\n\n@media screen and (max-width: 1640px){\n  .motionText {\n    font-size: 160.43px;\n  }\n  .scrollDownText{\n    font-family: 'Satoshi', sans-serif;\n    font-size: 13px;\n  }\n}\n\n@media screen and (max-width: 1540px){\n  .motionText {\n    font-size: 140.43px;\n  }\n}\n\n@media screen and (max-width: 1440px){\n  .motionText {\n    font-size: 125.3px;\n  }\n}\n\n\n@media screen and (max-width: 1024px) {\n  .motionTextContainer {\n    padding-top: 15vh;\n    position: absolute;\n    top: 120%;\n  }\n  .motionText {\n    font-size: 100px;\n  }\n  .scrollDownText{\n    font-family: 'Satoshi', sans-serif;\n    font-size: 14px;\n  }\n  .motionTextContainer {\n    top: 60%;\n  }\n}\n@media screen and (max-width: 768px) {\n  .LandingPage {\n    background-image: linear-gradient(\n        to bottom,\n        rgba(0, 0, 0, 0) 70%,\n        rgba(0, 0, 0, 1) 90%\n      ),\n      url(\"../../../../public/Assets/Donation/LandingPage/mobileBackground.png\");\n    background-repeat: no-repeat;\n    background-size: cover;\n    background-position: center;\n    width: 100%;\n    height: 100%;\n  }\n  .donationLandingPageContainer{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n  .motionTextContainer {\n    top: 98%;\n    padding-top: 0vh;\n  }\n  .motionText {\n    font-size: 60px;\n  }\n  .scrollDownContainer{\n    margin-top: 9vh;\n  }\n  .scrollDownText{\n    font-family: 'Satoshi', sans-serif;\n    font-size: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
